import { createSelector } from 'reselect';

import { detectUserTimezone, findTimezoneByText } from '../../../utils/date';
import { IAppState } from '../../reducers';

export const selectCsLinkSettingsState = (state: IAppState) => state.createSend.linkSettings;

export const selectCsLinkTitleRaw = createSelector(selectCsLinkSettingsState, (link) => link.title);

export const selectCsLinkTitle = createSelector(selectCsLinkTitleRaw, (title) => title ?? '');

export const selectCsLinkExpirationDateRaw = createSelector(selectCsLinkSettingsState, (link) => link.expirationDate);

export const selectCsLinkExpirationDate = createSelector(selectCsLinkExpirationDateRaw, (date) => date ?? '');

export const selectCsLinkExpirationTimezone = createSelector(selectCsLinkSettingsState, (link) =>
  findTimezoneByText(link.expirationTimezone),
);

export const selectCsLinkExpirationTimezoneText = createSelector(
  selectCsLinkExpirationTimezone,
  (timezone) => (timezone ?? detectUserTimezone()).text,
);

export const selectCsLinkOnHoldUntilRaw = createSelector(selectCsLinkSettingsState, (link) => link.onHoldUntil);

export const selectCsLinkOnHoldUntil = createSelector(selectCsLinkOnHoldUntilRaw, (date) => date ?? '');

export const selectCsRedemptionLimitRaw = createSelector(selectCsLinkSettingsState, (link) => link.redemptionLimit);

export const selectCsRedemptionLimit = createSelector(selectCsRedemptionLimitRaw, (limit) => limit ?? null);

export const selectCsIsExpirationEnabled = createSelector(
  selectCsLinkSettingsState,
  (link) => link.isExpirationEnabled,
);

export const selectCsIsOnHoldEnabled = createSelector(selectCsLinkSettingsState, (link) =>
  Boolean(link.isOnHoldEnabled),
);

export const selectCsIsPasswordEnabled = createSelector(selectCsLinkSettingsState, (link) => link.isPasswordEnabled);

export const selectCsIsDomainsEnabled = createSelector(selectCsLinkSettingsState, (link) => link.isDomainsEnabled);

export const selectCsLinkPassword = createSelector(selectCsLinkSettingsState, (link) => link.password);

export const selectCsAllowedDomains = createSelector(selectCsLinkSettingsState, (link) => link.allowedDomains);

export const selectCsIs2FaEnabled = createSelector(selectCsLinkSettingsState, (link) => link.is2FaEnabled);

export const selectCsTwoFaRecipients = createSelector(selectCsLinkSettingsState, (link) => link.twoFaRecipients);
